<template>
  <div>
    <div
      v-for="(limitation, index) in limitations"
      :key="`pl${index}`"
    >
      <strong>{{labelFor(limitation.type)}}</strong> <span v-html="formatMaximum(limitation.amount)"/> db
    </div>
  </div>
</template>
<script>
import poolState from '../_poolState'
export default {
  props: {
    limitations: {
      required: true,
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    labelFor(type) {
      switch(type) {
        case 'test_campaign_creation':
          return 'Kampány:'
        case 'test_rating':
          return 'Értékelés:'
        default:
          return type
      }
    },
    formatMaximum(maximum) {
      if (maximum === -1) {
        return '&infin;'
      } else {
        return maximum
      }
    }
  }
}
</script>